import scrollToElement from "@ecom/ui/utils/scrollToElement"

export function scrollToPersonalForm() {
  const form = document.getElementById("form")

  if (form) {
    scrollToElement(form)
  }
}
